import React from "react";
import LogoSectigo from "../../../assets/images/logo_sectigo.png";
import TermsConditionsDialog from "../../commons/termsConditions/termsConditions";
import { StyledLoginFooter } from "../../styled/login";

export default function LoginFooter({
  terms,
  passwordRecovery,
  loginAccount,
  register,
}) {
  const [openTerms, setOpenTerms] = React.useState(false);

  const handleClick = () => {
    setOpenTerms(true);
  };

  const handleClose = () => {
    setOpenTerms(false);
  };

  return (
    <StyledLoginFooter.Footer>
      <div>
        <a
          href="https://sectigo.com/"
          target="_blank"
          rel="noopener noreferrer">
          <img src={LogoSectigo} alt="" />
        </a>
      </div>
      {register && (
        <div>
          <StyledLoginFooter.LinkStyled
            to="https://forms.office.com/Pages/ResponsePage.aspx?id=FaLFT-NXyESMjjLMW8rLBqQDWnRMtfVPnmmt4X0_35dUOFdXRkpFR1MzNlA3WVhSRjNFSlZZNThTTS4u"
            target="_blank"
            rel="noopener noreferrer">
            <p>Regístrese aquí</p>
          </StyledLoginFooter.LinkStyled>
        </div>
      )}
      {terms && (
        <div>
          <StyledLoginFooter.LinkStyled to="#" onClick={handleClick}>
            <p>Términos y condiciones</p>
          </StyledLoginFooter.LinkStyled>
        </div>
      )}
      {passwordRecovery && (
        <div>
          <StyledLoginFooter.LinkStyled to="/account/passwordRecovery">
            <p>¿Olvidó su contraseña?</p>
          </StyledLoginFooter.LinkStyled>
        </div>
      )}
      {loginAccount && (
        <div>
          <StyledLoginFooter.LinkStyled to="/account/login">
            <p>¿Ya tiene una cuenta?</p>
          </StyledLoginFooter.LinkStyled>
        </div>
      )}
      <TermsConditionsDialog
        open={openTerms}
        onClose={handleClose}></TermsConditionsDialog>
    </StyledLoginFooter.Footer>
  );
}
